export default __webpack_public_path__ + "static/media/facebook-icon.fc63d018.svg";